import { render } from "./SqlContent.vue?vue&type=template&id=604414eb&scoped=true"
import script from "./SqlContent.vue?vue&type=script&lang=js"
export * from "./SqlContent.vue?vue&type=script&lang=js"

import "./SqlContent.vue?vue&type=style&index=0&id=604414eb&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-604414eb"]])

export default __exports__